
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_19bso_4qndo_13",
  "inner-root": "awsui_inner-root_19bso_4qndo_14",
  "has-groups": "awsui_has-groups_19bso_4qndo_47",
  "compact-mode": "awsui_compact-mode_19bso_4qndo_51",
  "token": "awsui_token_19bso_4qndo_60",
  "inner-token": "awsui_inner-token_19bso_4qndo_61",
  "grouped": "awsui_grouped_19bso_4qndo_74",
  "list": "awsui_list_19bso_4qndo_86",
  "show-operation": "awsui_show-operation_19bso_4qndo_97",
  "select": "awsui_select_19bso_4qndo_103",
  "inner-select": "awsui_inner-select_19bso_4qndo_104",
  "token-content": "awsui_token-content_19bso_4qndo_108",
  "token-content-grouped": "awsui_token-content-grouped_19bso_4qndo_114",
  "inner-token-content": "awsui_inner-token-content_19bso_4qndo_119",
  "edit-button": "awsui_edit-button_19bso_4qndo_124",
  "dismiss-button": "awsui_dismiss-button_19bso_4qndo_125",
  "inner-dismiss-button": "awsui_inner-dismiss-button_19bso_4qndo_126",
  "token-disabled": "awsui_token-disabled_19bso_4qndo_184"
};
  